<template>
  <div>
    <div v-for="message in getMessages">
      <div
        class="modal-content"
        v-bind:class="{
          'info-message': message.type == 'info',
          'error-message': message.type == 'error'
        }"
      >
        <div style="display: inline-block;">
          <h4 v-if="message.type == 'info'">Info</h4>
          <h4 v-if="message.type == 'error'">Error</h4>
          <p v-html="message.text" />
        </div>
        <button
          class=" btn-default"
          style="float: right; margin-top:20px;"
          @click="removeMessage(message.key)"
        >
          OK
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "message-modal",
  computed: {
    ...mapGetters(["getMessages"])
  },
  methods: {
    ...mapMutations(["removeMessage"])
  }
};
</script>

<style scoped>
/* Modal Content */
.modal-content {
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 25vw;
  top: 20px;
  background-color: #fefefe;
  margin: auto;
  padding: 5px;
  border: 1px solid #888;
  border-radius: 8px;
  width: 50%;
}

h4,
p {
  margin-left: 20px;
}

.modal-content > h4 {
  padding-left: 5px;
}

.modal-content > p {
  margin: 0px;
  padding-left: 15px;
}

.modal-default-button {
  float: right;
}

.error-message {
  background-color: #ffcc00;
  opacity: 0.9;
}

.info-message {
  background-color: lightblue;
  opacity: 0.9;
}
</style>



// WEBPACK FOOTER //
// src/elements/messages.vue